import request from '@/axios/bulletinBoard'

// (移动端)-人员手机添加显示数据接口
export function getShowAllocation(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/hr_data/getShowAllocation',
    method: 'post',
    data
  })
}

// (移动端)人力增加面试情况接口
export function addInterviewInfo(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/hr_data/addInterviewInfo',
    method: 'post',
    data
  })
}

// (移动端)招聘计划列表
export function getPositionList(data) {
  return request({
    url: process.env.VUE_APP_HUMAN_API + '/data_warehouse/hr_data/getPositionList',
    method: 'post',
    data
  })
}
